<template>
  <el-dialog
    title="OSS信息查询"
    :visible="showOss"
    @close="closeOssDialog"
    @open="open"
    width="1000px"
    center
  >
    <el-tabs v-model="activeName">
      <el-tab-pane label="OSS数据" name="first">
        <div class="user-ossDialog-header">
          <el-select v-model="ossDir" @change="ossHandle">
            <el-option
              v-for="item in ossOpts"
              :key="item.value"
              :label="`${item.label}（${item.storage}）`"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <List-search
            ref="ossSearch"
            @listSearchEvn="listSearchEvn"
            @clearSearch="clearOssSearch"
          />
        </div>
        <div class="user-ossDialog-main" v-loading="ossLoading">
          <div class="global-body-wrap">
            <TableData
              :tableProps="ossProps"
              :tableData="limitData"
              :currentPage="ossPage"
              :pageSize="20"
            />
          </div>
          <Pagination
            :pageSize="20"
            :total="ossDataLength"
            :currentPage="ossPage"
            @pageNum="ossPageNum"
          />
        </div>
      </el-tab-pane>
      <el-tab-pane label="OSS统计图" name="second">
        <OssChart v-if="userId" :userId="userId"></OssChart>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>

<script>
import ListSearch from '@/components/listSearch'
import Pagination from '@/components/pagination'
import OssChart from './ossChart'
import TableData from '../tableData'

export default {
  props: {
    showOss: {
      type: Boolean,
      default: false
    },
    userId: {
      type: Number | String,
      default: ''
    }
  },
  components: {
    ListSearch,
    TableData,
    Pagination,
    OssChart
  },
  computed: {
    ossOpts() {
      return [
        {
          label: '备份',
          value: 'backup'
        },
        {
          label: '阅读笔记',
          value: 'reader'
        },
        {
          label: '新笔记',
          value: 'note'
        },
        {
          label: '旧笔记',
          value: 'notes'
        },
        {
          label: '推送',
          value: 'push'
        },
        {
          label: '存储',
          value: 'storage'
        },
        {
          label: '点文件',
          value: 'point'
        },
        {
          label: '资源',
          value: 'resource'
        },
        {
          label: '笔记封面',
          value: 'cover'
        },
        {
          label: '缩略图',
          value: 'thumbnail'
        },
        {
          label: '其他',
          value: 'share'
        }
      ]
    },
    ossProps() {
      return [
        {
          prop: 'name',
          label: '文件名'
        },
        {
          prop: 'size',
          label: '大小'
        }
      ]
    }
  },
  data() {
    return {
      ossDir: 'backup',
      ossData: [],
      limitData: [],
      searchData: [],
      ossPage: 1,
      ossDataLength: 0,
      ossSearch: '',
      ossLoading: false,
      activeName: 'first'
    }
  },
  methods: {
    async open() {
      await this.getUserOssStorage()
      this.ossDir = 'backup'
      this.checkOssInfo()
    },
    ossHandle() {
      this.ossPage = 1
      this.$refs.ossSearch.clearValue()
      this.checkOssInfo()
    },

    closeOssDialog() {
      this.$emit('close')
      this.activeName = 'first'
      this.ossPage = 1
      this.$refs.ossSearch.clearValue()
    },

    async checkOssInfo() {
      this.ossLoading = true
      try {
        this.ossData = await this.getUserOssData()
        this.cuttingData()
        this.ossLoading = false
      } catch (error) {
        this.ossLoading = false
      }
    },
    async getUserOssStorage() {
      try {
        let params = {
          userId: this.userId
        }
        let res = await this.$http.getUserOssStorage(params)
        for (let item of this.ossOpts) {
          item.storage = this.renderSize(res.data[item.value].data || 0)
        }
      } catch (error) {
        throw new Error(error)
      }
    },

    renderSize(value) {
      if (value === null || value === '' || !value) {
        return '0 B'
      }
      let unitArr = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      let index = 0
      let srcsize = parseFloat(value)
      index = Math.floor(Math.log(srcsize) / Math.log(1024))
      var size = srcsize / Math.pow(1024, index)
      //  保留的小数位数
      size = size.toFixed(2)
      return size + unitArr[index]
    },
    async getUserOssData() {
      try {
        let params = {
          userId: this.userId,
          dir: this.ossDir
        }
        let res = await this.$http.checkOssInfo(params)
        return res.data
      } catch (error) {
        throw new Error(error)
      }
    },
    cuttingData() {
      this.ossDataLength = this.ossData.length
      this.limitData = this.ossData.slice(
        (this.ossPage - 1) * 20,
        this.ossPage * 20
      )
    },
    cuttingSearchData() {
      this.limitData = this.searchData.slice(
        (this.ossPage - 1) * 20,
        this.ossPage * 20
      )
      this.ossDataLength = this.searchData.length
    },
    ossPageNum(page) {
      this.ossPage = page
      this.ossSearch ? this.cuttingSearchData() : this.cuttingData()
    },
    listSearchEvn(val) {
      this.ossSearch = val
      this.ossPage = 1
      this.searchData = this.ossData.filter(
        (item) => item.name.indexOf(val) !== -1
      )
      this.cuttingSearchData()
    },
    clearOssSearch() {
      this.ossSearch = ''
      this.ossPage = 1
      this.cuttingData()
    }
  }
}
</script>

<style lang="scss">
.user-ossDialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .user-ossDialog-header-right {
    display: flex;
    align-items: center;
    > .el-select {
      width: 100px;
    }
    > button {
      margin-top: 0;
      margin-left: 20px;
    }
  }
}
.user-ossDialog-main {
  margin-top: 20px;
}
</style>
